import { axiosInstance } from "../axios/axiosConfig";
import { PASS_API } from "../constants/pass";

const SKIP_LOADING_HEADERS = { "X-Skip-Loading": true };

const NO_CONTENT_STATUSES = [204, 401, 403, 404];

export const getAvailablePassProducts = async () => {
  try {
    const response = await axiosInstance.get(PASS_API.GET_AVAILABLE_PASSES, {
      headers: SKIP_LOADING_HEADERS,
    });
    return response?.data ?? [];
  } catch (error) {
    throw new Error(PASS_API.GET_AVAILABLE_PASSES_ERROR);
  }
};

export const getActivePass = async () => {
  try {
    const response = await axiosInstance.get(PASS_API.GET_ACTIVE_PASS, {
      headers: SKIP_LOADING_HEADERS,
    });
    return response?.data ?? null;
  } catch (error) {
    if (NO_CONTENT_STATUSES.includes(error?.response?.status)) {
      return null;
    }
    throw new Error(PASS_API.GET_ACTIVE_PASS_ERROR);
  }
};
